import PropTypes from 'prop-types';
import * as React from 'react';
import type ColumnSynchronizer from './ColumnSynchronizer';
import * as ColumnType from './ColumnType';
import DataTableHeaderLabelCell from './DataTableHeaderLabelCell';
import DataTableHeaderSelectionCell from './DataTableHeaderSelectionCell';
import type {ColumnPropType} from './propTypes';
import {columnPropType, columnSynchronizerPropType} from './propTypes';

export type Props = {
    columns: ColumnPropType[],
    columnSynchronizer?: ColumnSynchronizer,
    paddingColumn?: boolean,
    selected?: boolean,
    onSelectionChange?: (value: boolean, column: ColumnPropType) => void,
};

export default class DataTableHeaderRow extends React.PureComponent<Props> {

    static propTypes = {
        columns: PropTypes.arrayOf(columnPropType).isRequired,
        columnSynchronizer: columnSynchronizerPropType,
        paddingColumn: PropTypes.bool,
        selected: PropTypes.bool,
        onSelectionChange: PropTypes.func,
    };

    props: Props;

    renderCell = (column: ColumnType): React.ReactNode => {
        const {name, type} = column;
        const {columnSynchronizer, selected, onSelectionChange} = this.props;

        if (type === ColumnType.SELECTION) {
            return <DataTableHeaderSelectionCell key={name}
                                                 column={column}
                                                 columnSynchronizer={columnSynchronizer}
                                                 value={selected}
                                                 onChange={onSelectionChange}/>;
        }

        return <DataTableHeaderLabelCell key={name}
                                         column={column}
                                         columnSynchronizer={columnSynchronizer}/>;
    };

    render(): React.ReactNode {
        const {
            columns,
            columnSynchronizer,
            paddingColumn,
            selected,
            onSelectionChange,
            ...otherProps
        } = this.props;

        return (
            <tr {...otherProps}>
                {columns.map(this.renderCell)}
                {paddingColumn && <th/>}
            </tr>
        );
    }

}
